<template>
  <div class="animated fadeIn">
    <div class="kt-portlet kt-portlet--mobile" style="position:relative">
      <div class="kt-portlet__body kt-portlet__body--fit" ref="cnt">
        <div class="m-4">
          <div class="filters-container">
            <DropdownColumns v-model="fields" class="customize" />
          </div>
          <b-table
            id="companies-table"
            :busy.sync="isBusy"
            show-empty
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :hover="true"
            :striped="true"
            stacked="md"
            v-model="copy"
            :items="provider"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            @row-clicked="rowClicked"
            tbody-tr-class="tr-pointer"
            v-columns-resizable="{afterResize: columnsWidthChanged}"
          >
            <template v-slot:empty="scope">
              <div class="text-center">{{ $t(scope.emptyText) }}</div>
            </template>

            <template v-slot:head(name)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(cui)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(registration_number)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(address)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(license_number)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(ticket_footer_text)="data">{{ $t(data.label) }}</template>
            <!-- moved to Tenants.vue
            <template v-slot:head(default_shop_id)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(auth_url)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(bet_url)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(settle_url)="data">{{ $t(data.label) }}</template>
            -->

            <template v-slot:head(selected)>
              <label class="kt-checkbox kt-checkbox--single kt-checkbox--all kt-checkbox--solid">
                <input type="checkbox" @click.stop @change="selectAll" v-model="checkAll" />
                <span></span>
              </label>
            </template>
            <template v-slot:cell(selected)="data">
              <label class="kt-checkbox kt-checkbox--single kt-checkbox--all kt-checkbox--solid">
                <input type="checkbox" @click.stop :value="data.item.eid" v-model="selected" />
                <span></span>
              </label>
            </template>
          </b-table>
          <div class="container-fluid">
            <div class="row">
              <div style="white-space:nowrap;" class="my-2">
                <BulkActionSelect
                  v-model="bulkAction"
                  :options="bulkActionOptions"
                  variant="light"
                  class="mr-2"
                  size="sm"
                  v-if="selected.length"
                />
                <b-button
                  @click.stop="applySelected()"
                  size="sm"
                  class="mr-2 refresh"
                  variant="light"
                  v-if="selected.length"
                  :disabled="!bulkAction"
                >{{$t('Apply')}}</b-button>
                <span class="pagination-sep" v-if="selected.length"></span>

                <PaginationSelect
                  v-model="perPage"
                  :options="paginationOpts"
                  variant="light"
                  size="sm"
                />
                <span>
                  &nbsp;
                  <i18n path="Showing {start}-{end} of {total} rows" tag="span">
                    <span slot="start">{{(currentPage-1) * perPage + 1}}</span>
                    <span slot="end">{{currentPage * perPage}}</span>
                    <span slot="total">{{totalRows}}</span>
                  </i18n>
                </span>
                <b-button
                  size="sm"
                  @click.stop="$root.$emit('bv::refresh::table', 'companies-table')"
                  class="ml-2 refresh"
                  variant="light"
                  :title="$t('Refresh')"
                >
                  <i class="icon-refresh"></i>
                </b-button>
              </div>
              <nav class="ml-auto mt-2">
                <b-pagination
                  size="md"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  v-model="currentPage"
                />
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import startCase from "@/shared/strings";
import { errorConf } from "@/shared/notifications";
import tableMixin from "@/shared/mixins/table.mixin";
import PaginationSelect from "@/components/PaginationSelect";
import DropdownColumns from "@/components/DropdownColumns";
import BulkActionSelect from "@/components/BulkActionSelect";
import TableFilters from "@/components/TableFilters";

export default {
  components: {
    PaginationSelect,
    DropdownColumns,
    BulkActionSelect,
    TableFilters
  },
  name: "companies",
  mixins: [tableMixin],
  data: function() {
    return {
      tableName: "companies",

      bulkAction: null,
      bulkActionOptions: [],

      filterOptions: [],

      isBusy: false,
      sortBy: "name",
      sortDesc: false,
      fields: [
        {
          key: "selected",
          selected: false,
          ignore: true,
          class: "mw-select",
          dpIgnore: true
        },
        {
          key: "eid",
          label: "Id",
          sortable: false,
          ignore: true,
          class: "d-none"
        },
        {
          key: "uuid",
          label: "UUID",
          sortable: true,
          class: ""
        },
        { key: "name", sortable: true, class: "" },
        { key: "cui", label: "CUI", sortable: true, class: "" },
        {
          key: "registration_number",
          label: "Registration Number",
          sortable: true,
          class: ""
        },
        {
          key: "address",
          label: "Address",
          sortable: true,
          class: "",
          ignore: true
        },
        {
          key: "license_number",
          label: "License Number",
          sortable: true,
          class: ""
        },
        {
          key: "ticket_footer_text",
          label: "Ticket Footer",
          sortable: false,
          class: "d-none",
          ignore: true
        },
        /* // moved to Tenants.vue
        {
          key: "default_shop_id",
          label: "Default shop",
          sortable: false,
          ignore: true,
          class: "d-none"
        },
        {
          key: "auth_url",
          label: "Auth URL",
          sortable: false,
          ignore: true,
          class: "d-none"
        },
        {
          key: "bet_url",
          label: "Bet URL",
          sortable: false,
          ignore: true,
          class: "d-none"
        },
        {
          key: "settle_url",
          label: "Settle URL",
          sortable: false,
          ignore: true,
          class: "d-none"
        },
        */
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      filter: null,
      filterField: null,
      checkAll: false,
      selected: [],
      copy: null,
      addLabel: "Add company"
    };
  },
  watch: {
    selected(val) {
      if (val.length != this.copy.length) {
        this.checkAll = false;
      }
    }
  },
  methods: {
    refresh() {
      this.$root.$emit("bv::refresh::table", "companies-table");
    },
    selectAll() {
      this.selected = [];
      this.copy.forEach(item => {
        if (this.checkAll) {
          this.selected.push(item.eid);
        }
      });
    },
    applySelected() {
      const loading = this.$loading.open({
        container: this.$refs.cnt
      });

      const bulkData = {
        field: this.bulkAction.field,
        value: this.bulkAction.value,
        ids: this.selected
      };

      this.$store.dispatch("company/bulkAction", bulkData).finally(() => {
        loading.close();
        this.allSelected = false;
        this.selected = [];
        this.$root.$emit("bv::refresh::table", "companies-table");
      });
    },
    provider(ctx, callback) {
      const loading = this.$loading.open({
        container: this.$refs.cnt
      });

      const paginationData = {
        rowsPerPage: this.perPage,
        page: this.currentPage
      };

      if (this.filter && this.filterField) {
        paginationData.likeValues = [this.filter];
        paginationData.likeFields = [this.filterField];
      } else {
        paginationData.likeValues = [];
        paginationData.likeFields = [];
      }

      if (this.sortBy) {
        let sortBy = this.sortBy;
        if (sortBy == "etenant_id") sortBy = "tenant_id";
        paginationData.sortBy = [sortBy];
        paginationData.sortDirection = [this.sortDesc ? "DESC" : "ASC"];
      }

      const exactFields = [];
      const exactValues = [];

      this.filterOptions.forEach(item => {
        if (item.selected.length) {
          exactFields.push(item.field);
          if (item.trackBy) {
            const tmp = [];
            item.selected.forEach(el => {
              tmp.push(el[item.trackBy]);
            });
            exactValues.push(tmp);
          } else {
            exactValues.push(item.selected);
          }
        }
      });

      if (exactFields.length) {
        paginationData.exactFields = exactFields;
        paginationData.exactValues = exactValues;
      }

      this.$store
        .dispatch("company/fetch", paginationData)
        .then(resp => {
          this.totalRows = resp.data.total;
          callback(resp.data.rows);
        })
        .catch(err => {
          this.$bvToast.toast(
            this.$t(err.message),
            errorConf(this.$t("Error"))
          );
          this.totalRows = 0;
          callback([]);
        })
        .finally(() => {
          loading.close();
        });

      // Must return null or undefined to signal b-table that callback is being used
      return null;
    },
    rowClicked(item, index, event) {
      this.$router.push("/companies/" + item.eid);
    },
    redirect() {
      this.$router.push("/companies/0");
    }
  }
};
</script>

<style lang="scss" scoped>
</style>

